var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      { staticClass: "boss-layout-block" },
      [
        _vm.isWithdraw ? [_vm._m(0)] : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "boss-text boss-layout boss-layout-gap-between boss-layout-gap-large",
          },
          [
            _c("div", [
              _vm._v("\n        人事担当者\n        "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedResponsibleStaffId,
                      expression: "selectedResponsibleStaffId",
                    },
                  ],
                  staticClass: "boss-input-select",
                  attrs: { "data-test": "select-responsible-staffs" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedResponsibleStaffId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.updateResponsibleStaff,
                    ],
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [_vm._v("−")]),
                  _vm._v(" "),
                  _vm._l(_vm.responsibles, function (staff) {
                    return _c(
                      "option",
                      { key: staff.id, domProps: { value: staff.id } },
                      [
                        _vm._v(
                          "\n            " + _vm._s(staff.name) + "\n          "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "boss-layout-item-grow" }, [
              _c("div", { staticClass: "boss-layout boss-layout-top" }, [
                _c("div", { staticClass: "pega-layout-top-label" }, [
                  _vm._v("備考"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "boss-layout-item-grow" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.remarks,
                        expression: "remarks",
                      },
                    ],
                    staticClass:
                      "boss-input boss-input-fill pega-textarea-remarks",
                    attrs: {
                      rows: _vm.remarksRows,
                      "data-test": "text-remarks",
                      placeholder: "複数行入力が可能です",
                    },
                    domProps: { value: _vm.remarks },
                    on: {
                      change: _vm.updateRemarks,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.remarks = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "boss-table-wrap" }, [
      _c(
        "table",
        { staticClass: "boss-table-4" },
        [
          _c("tr", [
            _c("th", [
              _vm._v("選考フェーズ"),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content:
                          "選考フェーズの設定・編集は、「各種設定」メニューで行えます。",
                      },
                      expression:
                        "{ content: '選考フェーズの設定・編集は、「各種設定」メニューで行えます。'}",
                    },
                  ],
                  staticClass: "pega-circle",
                  attrs: { "data-test": "tooltip-phase" },
                },
                [_vm._v("?")]
              ),
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v("選考ステータス"),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content:
                          "選考ステータスの設定・編集は、「各種設定」メニューで行えます。",
                      },
                      expression:
                        "{ content: '選考ステータスの設定・編集は、「各種設定」メニューで行えます。'}",
                    },
                  ],
                  staticClass: "pega-circle",
                  attrs: { "data-test": "tooltip-status" },
                },
                [_vm._v("?")]
              ),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "pega-applicant-selection-date" }, [
              _vm._v("日時"),
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("評価")]),
            _vm._v(" "),
            _c("th", [_vm._v("評価コメント")]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.selections, function (selection, i) {
            return _c("entry-selection-outline", {
              key: i,
              attrs: {
                "entry-id": _vm.entryId,
                selection: selection,
                "is-withdraw": _vm.isWithdraw,
              },
            })
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout-block-large" }, [
      _c(
        "span",
        {
          staticClass: "boss-annotation-text font-size-1-1em text-center",
          attrs: { "data-test": "withdraw" },
        },
        [
          _c("div", [
            _vm._v(
              "\n            応募後に退会したため、マイページ表示・リマインドメール送信ができません。\n          "
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n            レジュメ内のご連絡先に、直接ご連絡ください。\n          "
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }